import styled, { css } from 'styled-components'

export const Pop = styled.circle`
  stroke-width: 3;
  display: block;
  fill: none;
  pointer-events: none;

  ${props =>
    props.layer === 'network'
      ? css`
          stroke: orange;
          fill: orange;
          stroke-width: 1;
        `
      : props.layer === 'ip'
      ? css`
          stroke: rgb(255, 200, 90);
          fill: rgb(255, 200, 90);
        `
      : props.layer === 'capacity'
      ? css`
          stroke: #0097ad;
          fill: #0097ad;
        `
      : props.layer === 'colocation' &&
        css`
          stroke: rgb(150, 54, 139);
          fill: rgb(150, 54, 139);
        `};

  ${props =>
    !props.active &&
    css`
      fill: none;
    `};

  ${props =>
    props.number &&
    css`
      stroke-width: 1;
      fill: #ffffff;
    `};

  ${props =>
    props.number &&
    props.active &&
    css`
      stroke-width: 3;
    `};

  ${props =>
    props.selected &&
    css`
      stroke-width: 6;
    `};
`

export const Ls = styled.rect`
  fill: rgb(0, 217, 255);
  stroke: rgb(0, 217, 255);
  stroke-width: 2px;
  pointer-events: none;  

  ${props =>
    props.telxius &&
    css`
      fill: rgb(0, 204, 88);
      stroke: rgb(0, 204, 88);
      stroke-width: 2px;
    `};

  ${props =>
    props.layer === 'network'
      ? css`
          fill: none;
        `
      : props.layer === 'cables'
      ? css``
      : css`
          display: none;
        `};

  ${props => 
    (props.layer === 'network' &&
    props.planned) &&
    css`
      fill: #c0d101;
      stroke: #c0d101;
      stroke-width: 2px;
    `}


    ${props => 
      (props.layer === 'network' ||
      props.layer === 'cables')  &&
      props.finished &&
      css`
        fill: #7d2677;
        stroke: #7d2677;
        stroke-width: 2px;
      `}
`

export const PointContainer = styled.g`
  z-index: 100;
  pointer-events: none;

  ${props =>
    props.active &&
    css`
      z-index: 102;
    `};

  ${props =>
    props.selected &&
    css`
      z-index: 103;
    `};
`

export const Name = styled.text`
  font-size: 12px;
  z-index: 4000;
  fill: #444;
  pointer-events: none;
  display: block;
  font-weight: 400;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${props =>
    props.selected &&
    css`
      font-size: 24px;
      display: block;
      z-index: 5000;
    `};
`

export const CableEnd = styled.rect`
  fill: #0097ad;
  stroke: none;
  pointer-events: none;
`

export const PopNumber = styled.text`
  fill: #000;
  font-size: 12px;
  font-weight: 700;
  z-index: 101;
  pointer-events: none;

  ${props =>
    props.selected &&
    css`
      font-size: 20px;
    `};
`

export const Action = styled.circle`
  fill: rgba(255, 255, 255, 0);
  stroke: none;
  cursor: pointer;
  pointer-events: all;
`
